import { DashboardContainer } from './components/DashboardContainer';

/**
 * ダッシュボードページ
 */
export const Dashboard = DashboardContainer;
